"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _icons = require("../images/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Icons
const iconLogoMap = {
  alert: _icons.Alert,
  android: _icons.AndroidIcon,
  android_line: _icons.AndroidIconLine,
  appicon: _icons.AppIcon,
  apple: _icons.AppleIcon,
  apple_line: _icons.AppleIconLine,
  arrow: _icons.ArrowIcon,
  awesome: _icons.Awesome,
  banner: _icons.BannerIcon,
  calendar: _icons.Calendar,
  check: _icons.Check,
  copy: _icons.Copy,
  creative_playable: _icons.CreativePlayable,
  creative_video: _icons.CreativeVideo,
  delete: _icons.Delete,
  dollar: _icons.Dollar,
  download: _icons.Download,
  downvote: _icons.Downvote,
  drag: _icons.Drag,
  duplicate: _icons.Duplicate,
  edit: _icons.Edit,
  empty_folder: _icons.EmptyFolder,
  error: _icons.ErrorIcon,
  executive: _icons.Executive,
  external_link: _icons.ExternalLink,
  fork: _icons.Fork,
  grid: _icons.Grid,
  image: _icons.Image,
  info: _icons.Info,
  interstitial: _icons.InterstitialIcon,
  ios: _icons.AppleIcon,
  list: _icons.List,
  loadingicon: _icons.LoadingIcon,
  rewarded: _icons.RewardedIcon,
  search: _icons.SearchIcon,
  star: _icons.Star,
  success: _icons.Success,
  trash: _icons.Trash,
  upload: _icons.Upload,
  upvote: _icons.Upvote,
  v: _icons.Video,
  video: _icons.RewardedIcon,
  zoom: _icons.ZoomOut,
  double_arrow: _icons.DoubleArrow,
  arrow_right: _icons.ArrowRight,
  thumbs_down: _icons.ThumbsDown,
  thumbs_up: _icons.ThumbsUp,
  tag: _icons.Tag,
  tags: _icons.Tags,
  comment: _icons.Comment,
  metric: _icons.Metric,
  play: _icons.Play,
  settings: _icons.Settings,
  smile: _icons.Smile,
  sparkles: _icons.Sparkles,
  more: _icons.More
};

const getIconComponent = type => {
  const component = iconLogoMap[type];
  return component === undefined ? _icons.AppIcon : component;
};

const iconProfile = {
  standard: {
    fill: _BaseTheme.default.colors.gray
  },
  selected: {
    fill: _BaseTheme.default.colors.blue
  }
};

const IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "design-system__sc-12cmztf-0"
})(["text-align:", ";max-width:", ";max-height:", ";& svg{fill:", ";}& > svg{margin:0 auto;max-width:", ";max-height:", ";}"], _ref => {
  let {
    align
  } = _ref;
  return align;
}, _ref2 => {
  let {
    size
  } = _ref2;
  return "".concat(size, "px");
}, _ref3 => {
  let {
    size
  } = _ref3;
  return "".concat(size, "px");
}, _ref4 => {
  let {
    profile,
    disabled
  } = _ref4;
  return disabled ? _BaseTheme.default.colors.lightgray : iconProfile[profile].fill;
}, _ref5 => {
  let {
    size
  } = _ref5;
  return "".concat(size, "px");
}, _ref6 => {
  let {
    size
  } = _ref6;
  return "".concat(size, "px");
});

const Icon = _ref7 => {
  let {
    type,
    size,
    align,
    disabled,
    profile,
    className,
    title
  } = _ref7;
  const IconComponent = getIconComponent(type.toLowerCase());
  return /*#__PURE__*/_react.default.createElement(IconWrapper, {
    className: className,
    size: size,
    align: align,
    profile: profile,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement("svg", null, title && /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement(IconComponent, {
    disabled: disabled,
    fill: iconProfile[profile].fill
  })));
};

Icon.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(iconLogoMap)).isRequired,
  size: _propTypes.default.string,
  align: _propTypes.default.oneOf(['left', 'center', 'right']),
  disabled: _propTypes.default.bool,
  profile: _propTypes.default.oneOf(['standard', 'selected']),
  className: _propTypes.default.string,
  title: _propTypes.default.string
};
Icon.defaultProps = {
  size: '100',
  align: 'left',
  disabled: false,
  profile: 'standard',
  className: '',
  title: ''
};
var _default = Icon;
exports.default = _default;